<ion-menu side="end" menuId="mobileMenu" contentId="main" class="my-custom-menu"
[swipeGesture]="swipe"
maxEdgeStart="0"
type="overlay"
(ionDidOpen)="onIonDidOpen($event, true)"
(ionDidClose)="onIonDidOpen($event, false)"
[ngClass]="{'mt-[30px]': !networkIsActive}"
>

	<ion-content class=""  [ngClass]="menuGradientActive ? 'side-menu-mobile-gradiant-container' : 'side-menu-mobile-container'">
		<section class=" text-white pb-4 flex flex-col min-h-full">
			<!-- User - avatar -->
			<div class="flex items-center justify-between pl-6 pr-5 py-3 mb-3">
				<div class="w-auto flex items-center">
					<!-- back arrow: only when the access selector is open -->
					<ion-icon *ngIf="modulesOptionsIsOpen" name="chevron-back-outline" (click)="closeModulesOptions()" class="text-2xl text-white mr-2 cursor-pointer"></ion-icon>
					<div class="w-auto flex items-center" (click)="to('usuario/mi-perfil')">
						<div class="flex items-center justify-center mr-5">
							<div
								class="user-icon bg-secondary flex justify-center items-center font-black text-xl p-6 text-white">
								{{initials ? initials : initialsProp }}
							</div>
						</div>
						<div  class="w-full pr-2 flex flex-col gap-1">
							<span class="text-lg font-bold">{{ ( (data_usuario && data_usuario.full_name) ? data_usuario.full_name : dataUsuarioProp?.full_name)| titlecase }}</span>
							<span class="text-sm">{{ ( data_usuario?.workspace?.name ? data_usuario?.workspace?.name : dataUsuarioProp?.workspace?.name)| titlecase }}</span>
						</div>
					</div>
				</div>
				<div class="h-full flex justify-end self-start ml-2 cursor-pointer" (click)="cerrarMenu()">
					<ion-icon name="close-circle" class="text-3xl text-white"></ion-icon>
				</div>
			</div>

			<!-- Side menu items (hidden while the access selector is open) -->
			<nav *ngIf="!modulesOptionsIsOpen" class="pl-6 flex-1">
				<div *ngIf="isCordovaApp && (hasCoursesOffline || hasChecklistOffline) && !platformTypeInduction" class="item menu-toggle-wrapper mb-4 flex items-center justify-between px-2 mr-5 ">
					<div class="flex items-center justify-start gap-3" (click)="toggleNetwork()" >
						<ion-toggle class="toggle-filter " [checked]="!networkIsActive" [disabled]="true" mode="md"></ion-toggle>
						<mat-icon class="mdi  text-white text-base mdi-cloud-off-outline" [ngClass]="networkIsActive ? 'opacity-50' : 'opacity-100' "></mat-icon>
						<ion-label class="text-sm" [ngClass]="networkIsActive ? 'opacity-50' : 'opacity-100' ">Modo sin conexión</ion-label>
					</div>
				</div>

        <div *ngIf="networkIsActive" (click)="showNotification()" class="item mb-4 flex items-center justify-between px-2 mr-5">
          <div class="flex items-center justify-start">
            <div class="relative mr-4">
              <mat-icon class="mdi mdi-bell text-white text-xl"></mat-icon>
              <mat-icon class="mdi mdi-circle-medium text-2xl icon-alert-notification" *ngIf="newNotification"></mat-icon>
            </div>
            <ion-label class="text-sm">{{ language === 'es' ? 'Notificaciones y actividades' : 'Notifications and Activities'}}</ion-label>
          </div>
          <ion-icon name="chevron-forward-outline" class="text-base text-white"></ion-icon>
        </div>
        <p class="text-base font-bold mb-3">{{language === 'es' ? 'Selección de accesos' : 'Access Selection'}}</p>


        <ng-container *ngIf="networkIsActive else offlineActive">
          <div class="item mb-4" *ngFor="let group of array_menu2; index as i"  [ngClass]="{ active: displayAccordionSection === i && group.isGrouped }">
            <header (click)="group.isGrouped ? accordeonActive(i) : to(group.groupedItems[0].path, i)"
              class="flex items-center justify-between px-2 mr-5"
              [ngClass]="{
                'bg-secondary rounded-default': groupSelected === i
              }"
            >
              <div class="flex items-center justify-start">
                <ion-icon [src]="group.groupIcon" slot="start" class="text-white text-xl mr-4"></ion-icon>
                <span class="text-white text-base font-normal">{{group.groupName}}</span>
              </div>
              <ion-icon *ngIf="!group.isGrouped" name="chevron-forward-outline" class="text-base text-white"></ion-icon>
              <ion-icon *ngIf="group.isGrouped" name="chevron-down-outline"
                [ngClass]="{ 'rotate-180': displayAccordionSection == i, 'rotate-0': displayAccordionSection !== i }"
                class="text-base text-white transition-transform duration-200 transform">
              </ion-icon>
            </header>
            <ng-container *ngIf="group.isGrouped">
              <div
                class="mt-2 ml-9 px-2  mr-5 flex items-center justify-start leading-10"
                *ngFor="let item of group.groupedItems; index as subindex"
                (click)="to(item.path, null, subindex)"
                [ngClass]="{
                  'bg-secondary rounded-default': groupSelected === i && subGroupSelected === subindex
                }"
              >

                <ion-icon [src]="item.icon" slot="start" class="text-white text-xl mr-4"></ion-icon>
                <span class="text-white text-base font-normal">	{{item.name}}</span>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <ng-template #offlineActive>
          <div class="item mb-4" *ngFor="let group of array_menu2; index as i" >
            <header (click)="group.offlineCode === 'courses' && hasCoursesOffline ? toOfflineCourses()
            : group.offlineCode === 'checklist' && hasChecklistOffline ? toOfflineChecklist() : '' "
              class="flex items-center justify-between px-2 mr-5"
              [ngClass]="(group.offlineCode === 'courses' && hasCoursesOffline) || (group.offlineCode === 'checklist' && hasChecklistOffline) ? '' : 'opacity-50'"
            >
              <div class="flex items-center justify-start">
                <ion-icon [src]="group.groupIcon" slot="start" class="text-white text-xl mr-4"></ion-icon>
                <span class="text-white text-base font-normal">{{group.offlineCode === 'checklist' ? 'Checklist' : group.groupName}}</span>
              </div>
              <ion-icon  name="chevron-forward-outline" class="text-base text-white"></ion-icon>
            </header>
          </div>
        </ng-template>
			</nav>

			<!-- Access selector open state: empty hint centered in the freed space -->
			<div *ngIf="modulesOptionsIsOpen" class="flex-1 flex flex-col items-center justify-center px-6 text-center">
				<mat-icon class="mdi mdi-cursor-default-click-outline access-empty-icon text-white mb-3"></mat-icon>
				<p class="text-base text-white max-w-[12rem]">{{ language === 'es' ? 'Selecciona un espacio para acceder' : 'Select a process to access' }}</p>
			</div>

			<!-- Footer: access selector + logout (always visible) -->
			<div class="mt-auto">
				<!-- multi workspace / access selector -->
				<div *ngIf="networkIsActive && ((modulesOptions && modulesOptions.length) || hasPerformanceModule)" class="px-6 pb-3">
					<!-- OPEN: expanded list of accesses -->
					<div *ngIf="modulesOptionsIsOpen" class="access-options-list flex flex-col gap-2">
						<div (click)="selectWorkspace(module)" *ngFor="let module of modulesOptions"
							class="side-nav-modules-opt access-option grid items-center py-3 px-3 rounded-default cursor-pointer"
							[ngClass]="isWorkspaceSelected(module) ? 'access-option--selected' : 'access-option--unselected'"
						>
							<div class="flex gap-1 items-center">
								<mat-icon *ngIf="module.platform?.code === 'training'" class="mdi mdi-human-male-board text-xl leading-[18px] text-primary"></mat-icon>
								<mat-icon *ngIf="module.platform?.code === 'onboarding'" class="mdi mdi-card-account-details text-xl leading-[18px] text-primary"></mat-icon>
							</div>
							<span class="pl-4 justify-self-start" [ngClass]="{'font-bold': isWorkspaceSelected(module)}">{{module.platform?.name + " - " + module.subworkspace?.name}} </span>
							<img [src]="module.subworkspace?.logo" class="w-5 h-5 rounded-full border-1 border-secondary object-contain" />
						</div>

						<!-- Origin platform (training/onboarding): lets the user go back from Performance -->
						<div *ngIf="showOriginAccess" (click)="toOriginPlatform()"
							class="side-nav-modules-opt access-option grid items-center py-3 px-3 rounded-default cursor-pointer"
							[ngClass]="isOriginSelected ? 'access-option--selected' : 'access-option--unselected'"
						>
							<div class="flex gap-1 items-center">
								<mat-icon class="mdi text-xl leading-[18px] text-primary" [ngClass]="originAccess.icon"></mat-icon>
							</div>
							<span class="pl-4 justify-self-start" [ngClass]="{'font-bold': isOriginSelected}">{{ originAccess.label }}</span>
							<ion-icon *ngIf="isOriginSelected" name="checkmark-circle" class="text-xl text-primary justify-self-end"></ion-icon>
						</div>

						<!-- Desempeño: no logo, shows a check only when it is the selected access -->
						<div *ngIf="hasPerformanceModule" (click)="toPerformanceModule()"
							class="side-nav-modules-opt access-option grid items-center py-3 px-3 rounded-default cursor-pointer"
							[ngClass]="isPerformanceSelected ? 'access-option--selected' : 'access-option--unselected'"
						>
							<div class="flex gap-1 items-center">
								<mat-icon class="mdi mdi-chart-box-outline text-xl leading-[18px] text-primary"></mat-icon>
							</div>
							<span class="pl-4 justify-self-start" [ngClass]="{'font-bold': isPerformanceSelected}">{{ language === 'es' ? 'Desempeño' : 'Performance' }}</span>
							<ion-icon *ngIf="isPerformanceSelected" name="checkmark-circle" class="text-xl text-primary justify-self-end"></ion-icon>
						</div>
					</div>

					<!-- CLOSED: glass pill showing the currently selected access -->
					<button *ngIf="!modulesOptionsIsOpen" (click)="showMultimoduleOptions()" class="access-selector-pill w-full rounded-default px-4 py-4 grid grid-cols-[auto_1fr_auto] items-center text-white">
						<mat-icon class="mdi text-xl leading-[20px] text-white" [ngClass]="selectedAccess.icon"></mat-icon>
						<span class="pl-4 justify-self-start truncate">{{ selectedAccess.label }}</span>
						<mat-icon class="mdi mdi-swap-horizontal text-xl leading-[20px] text-white"></mat-icon>
					</button>
				</div>

				<!-- Log out -->
				<div class="pl-6">
					<div class="h-10 flex items-center justify-start px-2   w-full" [ngClass]="{'opacity-50': !networkIsActive}" (click)="networkIsActive ? confirmarSalir() : null" >
						<ion-icon src="assets/icon/logout.svg"  slot="start" class="text-white text-xl mr-4"></ion-icon>
						<span class="text-white text-base font-medium">{{language === 'es' ? 'Cerrar sesión' : 'Log out'}}</span>
					</div>
				</div>
			</div>
		</section>
	</ion-content>
</ion-menu>
